import { useTranslation } from 'react-i18next';
import { Role } from './types';

export default ({ label }: { label: string }) => {
  const { t } = useTranslation('COMMON');

  return label ? (
    <div className='flex max-w-max justify-center rounded-xl bg-gray-100 px-3 py-0.5 text-xs leading-4'>{t(label.toLowerCase() as Role)}</div>
  ) : null;
};
